export abstract class LoginService {
  abstract loginWithRedirect(): void;
}
